import { NeoModel, Validation } from '@singularsystems/neo-core';
import ApiModelBase from '../ApiModelBase';

@NeoModel
export default class Region extends ApiModelBase {

    public regionID: number = 0;

    public regionName: string = "";

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew || !this.regionName) {
            return "New region";
        } else {
            return this.regionName;
        }
    }
}